package com.cybersoftsolution.cybersoftsolutionweb.components.textfield

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.placeholderColor
import com.stevdza.san.kotlinbs.util.UniqueIdGenerator
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.autoComplete
import org.jetbrains.compose.web.attributes.maxLength
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input


@Composable
fun MyTextField(
    usePlaceholderColorStyle: Boolean = false,
    enabled: Boolean = true,
    text: String? = null,
    maxLength: Int? = null,
    modifier: Modifier = Modifier
        .width(350.px)
        .height(54.px)
        .padding(leftRight = 24.px)
        .margin(bottom = 12.px)
        .fontSize(16.px)
    ,
    style: CssStyle<GeneralKind>? = null,
//    style: CssStyle<GeneralKind> = LoginStyle,
    inputTypeHTML: InputTypeHTML = InputTypeHTML.Text,
    id: String? = null,
    placeholder : String = "",
    onChange : (String) -> Unit = {},
    onEnter : () -> Unit = {},
    autoComplete: AutoComplete = AutoComplete.off,
    ){





    val styleModifier = style?.toModifier() ?: Modifier

    val randomId = remember {
       id ?: UniqueIdGenerator.generateUniqueId("input")
    }

//    LaunchedEffect(text) {
//        (document.getElementById(randomId) as HTMLInputElement).value = text.orEmpty()
//    }

    Input(
        type = inputTypeHTML.type,
        attrs = styleModifier
            .then(modifier)
            .thenIf(
                condition = usePlaceholderColorStyle,
                other = placeholderColor.toModifier()
            )
            .id(randomId)

//            .onKeyUp {
//                val myTextFieldValue = (document.getElementById(id) as HTMLInputElement).value
//                onChange(myTextFieldValue)
////            console.info("myTextFieldId.${id} ------------ value = " +  myTextFieldValue)
//            }
            .onKeyDown {
                if (it.key == "Enter") {
//                    (document.getElementById(randomId) as HTMLInputElement).blur()
                    onEnter()
                }
            }
            .disabled(!enabled)
            .styleModifier {
                property("search-text-no::placeholder", Theme.Red.hex)
            }
            .styleModifier {
                CssStyle {
                    cssRule(".search-text-no::placeholder") {
                        Modifier.color(Colors.Red)
                    }
                }
            }
            .toAttrs {
                onInput { onChange(it.value) }
                attr("search-text-no::placeholder", Theme.Red.hex)
//                attr("placeholder", placeholder)
//                attr("value", text.orEmpty())
                value(text.orEmpty())
                placeholder(placeholder)
                autoComplete(autoComplete)
                if (maxLength != null)
                maxLength(maxLength)
            }

    )





}

sealed class InputTypeHTML(val type: InputType<String>) {
    object Text : InputTypeHTML(InputType.Text)
    object Password : InputTypeHTML(InputType.Password)
    object Email : InputTypeHTML(InputType.Email)
}